app.service('keycloak', function (modal, loading, orderConfig, front) {
	function showModal({ type, paymentName, voucherCode, paymentCode }) {
		if (orderConfig.getData().keycloakEnabled) {
			let header, content, redirectUrl, actionText;
			switch (type) {
				case 'k4-register':
					header = 'Płatność dostępna po zalogowaniu';
					content = `<p>Aby wybrać ${paymentName}, załóż konto. Konto możesz założyć na e-mail <strong>${orderConfig.getData().guestData.email}</strong> i dane z zamówienia. Wystarczy, że ustawisz hasło.</p>`;
					redirectUrl = '/order-register.bhtml' + (paymentCode ? `?paymentTypeCode=${paymentCode}` : '');
					actionText = 'Załóż konto';
					break;
				case 'k4-login':
					header = 'Płatność dostępna po zalogowaniu';
					content = `<p>Aby wybrać ${paymentName}, zaloguj się. Już masz ${front.euro ? 'Konto Moje Euro' : 'Konto Klienta'}, twój login to: <strong>${orderConfig.getData().guestData.email}</strong>.</p>`;
					redirectUrl = '/order-login.bhtml' + (paymentCode ? `?paymentTypeCode=${paymentCode}` : '');
					actionText = 'Zaloguj się';
					break;
				case 'k1-voucher':
					header = 'Kod dostępny po zalogowaniu';
					content = '<p>Aby skorzystać z kodu rabatowego, zaloguj się na swoje konto.</p>';
					redirectUrl = `/order-login.bhtml?voucherCode=${voucherCode}`;
					actionText = 'Zaloguj się';
					break;
				default:
					console.log('Unknown modal type');
					return;
			}
			modal.generate({
				id: 'modal-keycloak-confirm',
				header: header,
				content: content,
				buttons: [
					{
						text: 'Wróć do koszyka',
						cssClass: 'btn-action-back',
						click: function () {
							UA.push({
								event: 'button_click',
								button_name: 'return_to_basket',
								button_text: 'Wróć do koszyka'
							});
							modal.close();
						}
					}, {
						text: actionText,
						cssClass: 'btn-action-next',
						click: function () {
							redirect({ url: redirectUrl, buttonText: actionText })
						}
					}
				]
			});
		} else {
			console.log('Keycloak is not enabled');
		}
	}

	function redirect({ url, buttonText }) {
		UA.push({
			event: 'button_click',
			button_name: 'go_to_login_page',
			button_text: buttonText,
			button_details: 'link'
		});
		loading.redirect({
			href: url,
			soft: false
		});
	}

	return {
		showModal, redirect
	};
});
